<template>
  <AppHeader fixed>
    <SidebarToggler class="d-lg-none" display="md" mobile />
    <b-link class="navbar-brand" to="/">
      <img
        class="navbar-brand-full"
        src="/assets/img/logo.jpg"
        width="89"
        height="25"
        alt="PGSA"
      />
      <img
        class="navbar-brand-minimized"
        src="/assets/img/logo.jpg"
        width="30"
        height="30"
        alt="PGSA"
      />
    </b-link>
    <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen="true" />
    <!-- <b-navbar-nav class="d-md-down-none">
      <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
      <b-nav-item class="px-3" to="/users" exact>Users</b-nav-item>
      <b-nav-item class="px-3">Settings</b-nav-item>
    </b-navbar-nav> -->
    <b-navbar-nav class="ml-auto">
      <!-- <b-nav-item class="d-md-down-none">
        <i class="icon-bell"></i>
        <b-badge pill variant="danger">5</b-badge>
      </b-nav-item>
      <b-nav-item class="d-md-down-none">
        <i class="icon-list"></i>
      </b-nav-item>
      <b-nav-item class="d-md-down-none">
        <i class="icon-location-pin"></i>
      </b-nav-item> -->
      <b-nav-item class="d-md-down-none">
        <div v-if="user"><span v-if="isBirthday">🎉 Feliz aniversário, </span>{{ user.name }}</div>
      </b-nav-item>
      <DefaultHeaderDropdownAccnt />
    </b-navbar-nav>
    <!-- <AsideToggler class="d-none d-lg-block" /> -->
    <!--<AsideToggler class="d-lg-none" mobile />-->
  </AppHeader>
</template>
<script>
import { Header as AppHeader, SidebarToggler, AsideToggler } from '@coreui/vue'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import axios from 'axios'

export default {
  name: 'DefaultHeader',
  components: {
    AsideToggler,
    AppHeader,
    DefaultHeaderDropdownAccnt,
    SidebarToggler
  },
  data() {
    return {
      user: {},
      isBirthday: false
    }
  },
  mounted() {
    const user = this.$store.state.auth.user
    axios.get('/crm/employees/' + user.pk + '/')
    .then(res => {
      this.user = res.data.data;
      this.checkIfBirthday()
    })
  },
  methods: {
    checkIfBirthday() {
      const today = new Date();
      const birthday = new Date(this.user.birthday + "T00:00:00");
      if (today.getDate() === birthday.getDate() && today.getMonth() === birthday.getMonth()) {
        this.isBirthday = true;
      }
    }
  }
}
</script>
